import { graphqlShopifyStorefront } from "@repo/graphql-shopify-storefront";
// import { Customer_Fragment } from "#/graphql/shopify-storefront/fragments";

export const CustomerAccessTokenCreate_Mutation = graphqlShopifyStorefront(`
  mutation CustomerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {
    customerAccessTokenCreate(input: $input) {
      customerAccessToken {
        accessToken
        expiresAt
      }
      customerUserErrors {
        code
        field
        message
      }
    }
  }
`);

export const CustomerAccessTokenDelete_Mutation = graphqlShopifyStorefront(`
  mutation CustomerAccessTokenDelete($customerAccessToken: String!) {
    customerAccessTokenDelete(customerAccessToken: $customerAccessToken) {
      deletedAccessToken
      deletedCustomerAccessTokenId
      userErrors {
        field
        message
      }
    }
  }
`);

export const CustomerAddressCreate_Mutation = graphqlShopifyStorefront(`
  mutation CustomerAddressCreate($address: MailingAddressInput!, $customerAccessToken: String!) {
    customerAddressCreate(
      address: $address
      customerAccessToken: $customerAccessToken
    ) {
      customerAddress {
        id
      }
      customerUserErrors {
        code
        field
        message
      }
    }
  }
`);

export const CustomerAddressDelete_Mutation = graphqlShopifyStorefront(`
  mutation CustomerAddressDelete($customerAccessToken: String!, $id: ID!) {
    customerAddressDelete(customerAccessToken: $customerAccessToken, id: $id) {
      customerUserErrors {
        code
        field
        message
      }
      deletedCustomerAddressId
    }
  }
`);

export const CustomerAddressUpdate_Mutation = graphqlShopifyStorefront(`
  mutation CustomerAddressUpdate($address: MailingAddressInput!, $customerAccessToken: String!, $id: ID!) {
    customerAddressUpdate(address: $address, customerAccessToken: $customerAccessToken, id: $id) {
      customerAddress {
        id
      }
      customerUserErrors {
        code
        field
        message
      }
    }
  }
`);

export const CustomerCreate_Mutation = graphqlShopifyStorefront(`
  mutation CustomerCreate($input: CustomerCreateInput!) {
    customerCreate(input: $input) {
      customerUserErrors {
        code
        field
        message
      }
      customer {
        id
      }
    }
  }
`);

export const CustomerDefaultAddressUpdate_Mutation = graphqlShopifyStorefront(`
  mutation CustomerDefaultAddressUpdate(
    $id: ID!
    $customerAccessToken: String!
  ) {
    customerDefaultAddressUpdate(
      addressId: $id
      customerAccessToken: $customerAccessToken
    ) {
      customerUserErrors {
        code
        field
        message
      }
    }
  }
`);

export const CustomerRecover_Mutation = graphqlShopifyStorefront(`
  mutation CustomerRecover($email: String!) {
    customerRecover(email: $email) {
      customerUserErrors {
        code
        field
        message
      }
    }
  }
`);

export const CustomerReset_Mutation = graphqlShopifyStorefront(`
  mutation CustomerReset($id: ID!, $input: CustomerResetInput!) {
    customerReset(id: $id, input: $input) {
      customerAccessToken {
        accessToken
        expiresAt
      }
      customerUserErrors {
        code
        field
        message
      }
    }
  }
`);

export const CustomerResetByUrl_Mutation = graphqlShopifyStorefront(`
  mutation CustomerResetByUrl($password: String!, $resetUrl: URL!) {
    customerResetByUrl(password: $password, resetUrl: $resetUrl) {
      customerAccessToken {
        accessToken
        expiresAt
      }
      customerUserErrors {
        code
        field
        message
      }
    }
  }
`);

export const CustomerUpdate_Mutation = graphqlShopifyStorefront(
  `
  mutation CustomerUpdate(
    $customerAccessToken: String!
    $input: CustomerUpdateInput!
  ) {
    customerUpdate(
      customerAccessToken: $customerAccessToken
      customer: $input
    ) {
      customerUserErrors {
        code
        field
        message
      }
      customerMasked: customer {
        ...Customer
      }
    }
  }
`,
  // [Customer_Fragment],
);
